import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { Violation } from './violation.contract';

@Injectable({
  providedIn: 'root'
})
export class ViolationService {
  private source: ReplaySubject<Violation[]> = new ReplaySubject<Violation[]>(
    1
  );

  public violations: Observable<Violation[]> = this.source;

  public updateViolations(violations: Violation[]): void {
    this.source.next(violations);
  }
}
